import Action from 'actions';
import {PositionInLineup} from 'helpers/lineup-helper';
import BaseLineup from 'services/sports/default/base-lineup';

export default class LineupClassic extends BaseLineup {
    setPlayersByColumns({incomingValues: {team, lineupId}}) {
        const {sportConfig} = Action.getState();
        const positionsOrder = sportConfig.getConfigProp('positionsOrder', {});

        const params = {
            team,
            positionsOrder,
            functions: this.exec('getFunctionsToSetPlayersByColumns', {lineupId}, {}),
        };

        let players = PositionInLineup.set.inDependenceOnOrder(params);

        if (!sportConfig.isModeLateswap()) {
            players = this.exec('forcePlayerToFlexPosition', {
                lineupPlayers: players,
            });
        }

        return [...players];
    }
}
